<footer>
  <section class="links">
    @for (link of primaryLinks; track link.label) {
      <a [href]="link.url">
        {{ link.label }}
      </a>
    }

    <div class="trust-pilot">
      <div
        role="heading"
        aria-level="2"
        class="trustpilot-widget"
        data-locale="en-GB"
        data-template-id="5419b6ffb0d04a076446a9af"
        data-businessunit-id="4cb3113600006400050dfb02"
        data-style-height="20px"
        data-style-width="100%"
        data-theme="dark"
      >
        <a href="https://uk.trustpilot.com/review/domesticandgeneral.com" target="_blank" rel="noopener">Trustpilot</a>
      </div>
    </div>
  </section>

  <p>
    Service plans, maintenance & support plans are provided by Domestic & General Services Limited. Insurance policies
    are provided by Domestic & General Insurance PLC. Domestic & General Insurance PLC is an insurance undertaking, not
    an intermediary. We are the underwriter of the insurance policies and do not provide a personal recommendation or
    advice. Domestic & General Insurance PLC is authorised by the Prudential Regulation Authority and regulated by the
    Financial Conduct Authority and the Prudential Regulation Authority (Financial Services Register Number 202111). Our
    address and details of our authorisation can be checked on the FCA website.
  </p>

  <section class="secondary-links">
    <p>© {{ currentYear }} Domestic & General Group Limited</p>
    @for (link of secondaryLinks; track link.label) {
      <a [href]="link.url">
        {{ link.label }}
      </a>
    }
  </section>
</footer>
